import React, { useState, useEffect } from 'react';
import { RotatingTriangles } from 'react-loader-spinner';

const AppLoader = () => {
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prevProgress => (prevProgress < 100 ? prevProgress + 1 : prevProgress));
    }, 1000);

    setTimeout(() => {
      setLoading(false);
      clearInterval(interval);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      {loading ? (
        <div style={{ textAlign: 'center' }}>
          <RotatingTriangles color="#FFF" height={100} width={100} />
          <p>Cargando... {progress}%</p>
        </div>
      ) : (
        <div>
          <span></span>
        </div>
      )}
    </div>
  );
};

export default AppLoader;